import React, { useState } from "react";
import { LeadService } from "../../../../../utils/api.service";
import { toast } from "react-toastify";
import "../components/LeadFormModal.scss";
import { X } from "lucide-react";

const ScheduleForm = ({ handleClose, showCloseIcon = false }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    restaurantName: "",
    phone: "",
    email: "",
    comments: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await LeadService.submitLead(formData);
      toast.success("Submitted successfully!");
      setFormData({
        name: "",
        restaurantName: "",
        phone: "",
        email: "",
        comments: "",
      });
      await handleClose();
    } catch (error) {
      toast.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="bg-white shadow p-lg-5 p-4 rounded-5 w-100 h-100 d-flex flex-column justify-content-center">
      <div className="section-title mb-4">
        <div className="d-flex align-items-center justify-content-between">
          <span className="badge rounded-pill bg-soft-primary py-2 px-3 fw-semibold">
            FREE DEMO
          </span>
          {showCloseIcon && (
            <X onClick={handleClose} style={{ cursor: "pointer" }} />
          )}
        </div>

        <h4 className="title fw-bold text-uppercase my-3">
          Schedule a free demo
        </h4>
        <p className="text-muted mx-auto para-desc mb-0">
          We make it a priority to offer flexible services to accomodate your
          needs
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-4">
            <label>
              Your Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mb-4">
            <label>
              Restaurant Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="restaurantName"
              className="form-control"
              placeholder="Enter your restaurant name"
              value={formData.restaurantName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mb-4">
            <label>
              Phone Number <span className="text-danger">*</span>
            </label>
            <input
              type="tel"
              name="phone"
              className="form-control"
              placeholder="Enter your mobile no"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mb-4">
            <label>
              Email <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12 mb-4">
            <label>
              Comments <span className="text-danger">*</span>
            </label>
            <textarea
              name="comments"
              rows="4"
              className="form-control"
              placeholder="Write your message"
              value={formData.comments}
              onChange={handleChange}
              required
            ></textarea>
          </div>
        </div>

        <button
          type="submit"
          className="rounded-3 btn btn-primary rounded-0  w-100"
        >
          {isSubmitting ? "Submitting..." : "Schedule"}
        </button>
      </form>
    </div>
  );
};

export default ScheduleForm;
